import {
  FieldValues,
  useForm as rhfUseForm,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";

export default function useForm<TFieldValues extends FieldValues = FieldValues>(
  props?: UseFormProps<TFieldValues>,
): UseFormReturn<TFieldValues> {
  return rhfUseForm<TFieldValues>(props);
}
